import React from "react";
import CommodityGrid from "@/components/CommodityGrid";
import { Coins } from "lucide-react";

export default function Commodities() {
  return (
    <div className="px-4 sm:px-6 lg:px-12 py-8">
      <div className="flex items-center gap-3 mb-1">
        <Coins className="w-5 h-5 text-amber-400" />
        <span className="text-xs font-mono-fin uppercase tracking-[0.3em] text-[#D91E2A]">MCX · Global Spot</span>
      </div>
      <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-slate-900 mb-2">Commodities & FX</h1>
      <p className="text-slate-500 mb-8 max-w-2xl">Live spot prices for Gold, Silver, Copper, Crude Oil, Natural Gas and the USD/INR pair — refreshed every 90 seconds.</p>
      <CommodityGrid />
    </div>
  );
}
